import apiClient from "@/api/apiClient";
import { type ArgsCreateWorkspace, type Workspace } from "@/supabase.types";
import { spawnUpdateApiFunction, type ApiResourceConfig } from "@/utils/api";

const table = "workspaces";
const query = "*";

export const apiConfigWorkspaces: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: ["name", "address_1", "address_2", "city", "zipcode", "country"],
  sortables: ["created_at", "updated_at", "name", "trial_end_date"],
};

export async function getWorkspaces() {
  const { data, error } = await apiClient.from(table).select(query).is("deleted_at", null);
  if (error) throw error;
  return data;
}

export async function getWorkspace(match: Partial<Workspace>) {
  const { data, error } = await apiClient.from(table).select(query).match(match).is("deleted_at", null).maybeSingle();
  if (error) throw error;
  return data;
}

export const createWorkspace = async (props: ArgsCreateWorkspace) => {
  const { error, ...rest } = await apiClient.rpc("create_workspace", props);
  if (error) throw error;

  return { error, ...rest };
};
export const updateWorkspace = spawnUpdateApiFunction({ table, query });
export const deleteWorkspace = async ({ id }: Pick<Workspace, "id">) => {
  const { error, ...rest } = await apiClient.rpc("delete_workspace", { _workspace_id: id });
  if (error) throw error;

  return { error, ...rest };
};

export async function getCustomerWorkspaces(workspace_id: string) {
  const { data, error } = await apiClient
    .from(table)
    .select("*, users_to_workspaces(*), deployments!deployments_workspace_id_fkey(id), devices(count)")
    .neq("id", workspace_id)
    .eq("creator_workspace_id", workspace_id)
    .is("deleted_at", null)
    .is("devices.deleted_at", null)
    .is("deployments.deleted_at", null);
  if (error) throw error;
  return data;
}
